import { Dropdown, Avatar, Menu } from 'antd';
import { CaretDownOutlined, LogoutOutlined } from '@ant-design/icons';
import { useDispatch, useSelector } from 'react-redux';
import { MenuInfo } from 'rc-menu/lib/interface';

import { RootState } from '../../redux';
import actions from '../../modules/auth/redux/actions';

import styles from './usermenu.module.css';
import { User } from '../../modules/auth/redux/types';

const getFullName = (user: User) => {
    return `${user.first_name ?? ''} ${user.last_name ?? ''}`.trim();
};

const UserMenu = () => {
    const dispatch = useDispatch();
    const user = useSelector((state: RootState) => state.auth.user);
    const handleMenuSelect = (info: MenuInfo) => {
        switch (info.key) {
            case '/logout':
                dispatch(actions.logout());
                break;
            default:
        }
    };

    if (!user) return <div />;

    const initial = user.first_name.toUpperCase()[0];
    return (
        <div className={styles.userMenu}>
            <Dropdown
                overlay={
                    <Menu onClick={handleMenuSelect}>
                        <Menu.Item key="">
                            <div>{getFullName(user)}</div>
                            <div>{user.email}</div>
                        </Menu.Item>
                        <Menu.Divider />
                        <Menu.Item key="/logout">
                            <LogoutOutlined />
                            <span>&nbsp;Cerrar sesión</span>
                        </Menu.Item>
                    </Menu>
                }
                trigger={['click']}
            >
                <span className={styles.menuToggle} title={getFullName(user)}>
                    <Avatar className={styles.avatar}>{initial}</Avatar>
                    {/* <span className={styles.name}>{firstName}</span> */}
                    <CaretDownOutlined />
                </span>
            </Dropdown>
        </div>
    );
};

export default UserMenu;
